import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { AuthApiFacade } from '@rx-applications/shared/auth/api';

export const AuthGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const configFacade = inject(ConfigFacade);
  const authFacade = inject(AuthApiFacade);

  return configFacade.isAuthenticatedAndConfigured$.pipe(
    map((isAuthenticatedAndConfigured: boolean) => {
      if (!isAuthenticatedAndConfigured) {
        authFacade.logoutAuthGuard(state.url);
        return false;
      }
      return true;
    }),
    take(1),
  );
};
